import React from "react"

// utils
import useBadges from "utilities/useBadges"

import PropTypes from "prop-types"

const WorkflowStatusBadge = ({ uniqueValues, value, isFlex }) => {
  const { Badge } = useBadges(uniqueValues)

  if (!uniqueValues || !value) return null

  return (
    <Badge
      value={value}
      isFlex={isFlex}
    />
  )
}

WorkflowStatusBadge.propTypes = {
  uniqueValues: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.string,
  isFlex: PropTypes.bool,
}

export default WorkflowStatusBadge
